import "./AcademyDrawer.css";
import { useState } from "react";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { AcademyGrid } from "../academy-grid";

export default function AcademyDrawer(props) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`closed_drawer ${open ? "open_drawer" : ""}`}>
      {!open ? (
        <div className="closedDrawerLeft">
          <div className="openText" onClick={() => setOpen(!open)}>
            <p style={{ padding: "0.25rem" }}>
              <AiOutlineRight />
            </p>
            <p className="sideText">Courses</p>
          </div>
        </div>
      ) : (
        <div id="openLeftDrawer">
          <div style={{ marginTop: "40px" }}>
            <AcademyGrid
              setExpandedCourse={props.setExpandedCourse}
              closeDrawer={setOpen}
            />
          </div>
          <div className="openText" onClick={() => setOpen(!open)}>
            <p style={{ padding: "0.25rem" }}>
              <AiOutlineLeft />
            </p>
            <p className="sideText">Collapse</p>
          </div>
        </div>
      )}
    </div>
  );
}
